import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2 } from 'lucide-react';

export function GRNStepReview({ selectedPO, receivedDate, items, totalOrdered, totalReceived, totalAccepted, disclaimerRemarks, notes }) {
  return (
    <div className="space-y-4">
      <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
        <div className="flex items-center gap-2 text-green-800">
          <CheckCircle2 size={20} />
          <span className="font-semibold">Review and Confirm GRN</span>
        </div>
        <p className="text-sm text-green-600 mt-1">
          Please review the details below before submitting. Stock will be updated immediately upon confirmation.
        </p>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="p-3 bg-gray-50 rounded-lg">
          <p className="text-xs text-gray-500 mb-2">PO Details</p>
          <p><strong>PO Number:</strong> {selectedPO.po_number}</p>
          <p><strong>Supplier:</strong> {selectedPO.supplier_name}</p>
          <p><strong>Received Date:</strong> {receivedDate}</p>
        </div>
        <div className="p-3 bg-gray-50 rounded-lg">
          <p className="text-xs text-gray-500 mb-2">Quantity Summary</p>
          <p><strong>Total Ordered:</strong> {totalOrdered}</p>
          <p><strong>Total Received:</strong> {totalReceived}</p>
          <p><strong>Total Accepted:</strong> <span className="text-green-600 font-bold">{totalAccepted}</span></p>
        </div>
      </div>
      
      <div className="border rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 text-left">Product</th>
              <th className="px-4 py-2 text-center">Ordered</th>
              <th className="px-4 py-2 text-center">Received</th>
              <th className="px-4 py-2 text-center">Accepted</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {items.map((item, idx) => (
              <tr key={`review-${item.product_id}-${idx}`} className={item.is_alternate ? 'bg-blue-50' : ''}>
                <td className="px-4 py-2">
                  {item.product_name}
                  {item.is_alternate && <Badge className="ml-2 text-xs">Alternate</Badge>}
                </td>
                <td className="px-4 py-2 text-center">{item.is_alternate ? '-' : item.ordered_quantity}</td>
                <td className="px-4 py-2 text-center">{item.received_quantity}</td>
                <td className="px-4 py-2 text-center font-semibold text-green-600">{item.accepted_quantity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {disclaimerRemarks && (
        <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-xs text-yellow-600 font-semibold mb-1">Disclaimer</p>
          <p className="text-sm">{disclaimerRemarks}</p>
        </div>
      )}
      
      {notes && (
        <div className="p-3 bg-gray-50 rounded-lg">
          <p className="text-xs text-gray-500 font-semibold mb-1">Notes</p>
          <p className="text-sm">{notes}</p>
        </div>
      )}
    </div>
  );
}
